import { isValidReferralCode, ReferralLinkResponse } from '@sportspredict/shared';
import { ROUTES } from '@/constants';

const REFERRAL_STORAGE_KEY = 'referral_code';

export function extractReferralCodeFromUrl(): string | null {
	const params = new URLSearchParams(window.location.search);

	const code = params.get('ref');
	return code && isValidReferralCode(code) ? code.toUpperCase() : null;
}

export function saveToStorage(code: string): void {
	localStorage.setItem(REFERRAL_STORAGE_KEY, code);
}

export function getFromStorage(): string | null {
	try {
		const code = localStorage.getItem(REFERRAL_STORAGE_KEY);
		return code && isValidReferralCode(code) ? code : null;
	} catch {
		return null;
	}
}

export function removeFromStorage(): void {
	localStorage.removeItem(REFERRAL_STORAGE_KEY);
}

export function buildLobbyDetailsUrl(lobbyId: string, eventId: string): string {
	return `${ROUTES.LOBBY_DETAILS}?source=default&id=${lobbyId}&eventId=${eventId}`;
}

export function buildProbabilityEventUrl(eventId: string): string {
	return `${ROUTES.PROBABILITY_EVENT}/${eventId}`;
}

const getRedirectPath = (data?: ReferralLinkResponse | null) => {
	if (!data?.eventId) return ROUTES.ROOT;

	if (data.isProbabilityEvent) {
		return buildProbabilityEventUrl(data.eventId);
	}

	if (data.lobbyId) {
		return buildLobbyDetailsUrl(data.lobbyId, data.eventId);
	}

	return ROUTES.ROOT;
};

export const redirectToLobbyOrRoot = (data?: ReferralLinkResponse | null) =>
	(window.location.href = `${window.location.origin}${getRedirectPath(data)}`);
